import { useState } from 'react'

import { currencyText } from '@/common/app/currency'

import TextButton from '@/components/view/atoms/button/TextButton'
import DisclosureWrapper from '@/components/view/layouts/disclosure/DisclosureWrapper'

import SamplingRateForm from '@/components/container/form/modules/site/samplingRate/SamplingRateForm'

interface Props {
  siteId: number
  samplingRate: number
  onComplete(samplingRate: number): void
}

const SamplingRateButton = ({ siteId, samplingRate, onComplete }: Props) => {
  const [showing, setShowing] = useState<boolean>(false)

  return (
    <DisclosureWrapper
      disclosureNode={
        <SamplingRateForm
          siteId={siteId}
          currentSamplingRate={samplingRate}
          onComplete={(samplingRate) => {
            samplingRate !== undefined && onComplete(samplingRate)
            setShowing(false)
          }}
        />
      }
      gap={4}
      isForm
      off={!showing}
    >
      <TextButton disclosure onClick={() => setShowing((showing) => !showing)}>
        配信率を変更する
      </TextButton>
    </DisclosureWrapper>
  )
}

export default SamplingRateButton
